import Vue from 'vue';
import productTransformer from '../../transformers/product';

const success = (data, resolve) => {
  const result = {
    errors: data.errors,
    data: productTransformer.fetchCollection(data.data),
  };
  resolve(result);
};

const failed = (error, reject) => reject(error);

export default data => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/products/update/bullkprocess', data)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/product/bulkUpdate.js